import React from 'react';
import TeamLogo from './TeamLogo';

/**
 * TeamRow - standings-list cell: rank pill, logo, name + owner + streak badge, right-aligned record.
 * Mirrors team.html's ".team-row". Used by LeagueStandings for the identity cell of each row.
 * Pass showRecord={false} when the caller already renders the W-L/roto/points columns itself,
 * to avoid showing a redundant (or, for non-H2H leagues, meaningless "0-0") record block.
 */
function TeamRow({ team, rank, streak, onClick, showRecord = true }) {
  if (!team) return null;
  const record = team.ties
    ? `${team.wins ?? 0}–${team.losses ?? 0}–${team.ties}`
    : `${team.wins ?? 0}–${team.losses ?? 0}`;
  const owner = team.ownerName || team.owner || team.ownerEmail;
  return (
    <div className="team-row" onClick={onClick}>
      {rank != null && <span className={`rank-pill ${rank === 1 ? 'gold' : ''}`}>{rank}</span>}
      <TeamLogo team={team} size={40} style={{ borderRadius: '50%' }} />
      <div className="trw-main">
        <div className="trw-name">{team.name}</div>
        <div className="trw-meta">
          {owner}
          {streak && <span className={`streak ${streak.startsWith('W') ? 'w' : 'l'}`}> {streak}</span>}
        </div>
      </div>
      {showRecord && (
        <div className="trw-rec">
          <div className="v">{record}</div>
          <div className="l">Record</div>
        </div>
      )}
    </div>
  );
}

export default TeamRow;
